import type { GetPollResults200OptionsItemAllOf } from './getPollResults200OptionsItemAllOf';
import type { GetPollResults200OptionsItemAllOfTwo } from './getPollResults200OptionsItemAllOfTwo';

export type GetPollResults200OptionsItem = GetPollResults200OptionsItemAllOf & GetPollResults200OptionsItemAllOfTwo;
